var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketSuper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 0C31.621 0 32.2334 0.14458 32.7889 0.422291C33.3443 0.700002 33.8274 1.10322 34.2 1.6L39.576 8.768C39.8452 9.1219 39.9887 9.5554 39.984 10H40V12C40.0001 13.9487 39.289 15.8305 38 17.292V32C38 33.0609 37.5786 34.0783 36.8284 34.8284C36.0783 35.5786 35.0609 36 34 36H6C4.93913 36 3.92172 35.5786 3.17157 34.8284C2.42143 34.0783 2 33.0609 2 32V17.292C0.711047 15.8305 -0.000121136 13.9487 1.54766e-08 12V10H0.0159998C0.0112738 9.5554 0.154836 9.1219 0.424 8.768L5.8 1.6C6.17259 1.10322 6.65572 0.700002 7.21115 0.422291C7.76657 0.14458 8.37902 0 9 0H31ZM36 12H28C27.9954 13.038 28.3944 14.0371 29.1128 14.7863C29.8311 15.5355 30.8126 15.9761 31.8499 16.0151C32.8871 16.054 33.8989 15.6882 34.6714 14.995C35.444 14.3018 35.9168 13.3354 35.99 12.3L36 12ZM24 12H16C15.9954 13.038 16.3944 14.0371 17.1128 14.7863C17.8311 15.5355 18.8126 15.9761 19.8499 16.0151C20.8871 16.054 21.8989 15.6882 22.6714 14.995C23.444 14.3018 23.9168 13.3354 23.99 12.3L24 12ZM12 12H4C3.99536 13.038 4.39437 14.0371 5.11276 14.7863C5.83114 15.5355 6.81263 15.9761 7.84988 16.0151C8.88712 16.054 9.89889 15.6882 10.6714 14.995C11.444 14.3018 11.9168 13.3354 11.99 12.3L12 12Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketSuper);
export default __webpack_public_path__ + "static/media/marketSuper.30f96f55d409f13e3b5aff8b722b980d.svg";
export { ForwardRef as ReactComponent };